<template>
  <div class="container">

    <b-modal
      v-model="publishConfirmationModal"
      content-class="airspirit-modal"
      hide-footer
      header-class="airspirit-modal-header"
      size="md"
    >
      <template #modal-header>
        <div 
          @click="closePublishModal"
          class="airspirit-modal-header--close-icon"
          style="float: left"
        >
          <img 
            :src="require('@/assets/images/pictos/croix.svg')"
          />
        </div>
        <div
          class="airspirit-modal-header--title"
          style=""
        >
          {{ $t('learn_modify_video.content_submitted') }}
        </div>
      </template>
      <p>
        {{ $t('learn_modify_video.content_submitted_message') }}
      </p>
      <button
        class="profile-validation-button"
        style="width: 100%;"
        @click="closePublishModal"
      >
        {{ $t('learn_modify_video.ok') }}
      </button>
    </b-modal>

    <ProfileTitleComponent
      :title="$t('learn_modify_video.title')"
      :subtitle="$t('learn_modify_video.subtitle')"
    />

    <create-or-modify-video
      :categories="categories"
      :create="false"
      :originalVideo="video"
      @create-or-modify-video="modifyVideo"
      @delete-video="deleteVideo"
    />

  </div>
</template>

<script>
import { APIUserConnected } from '@/api/APIUserConnected'
import ProfileTitleComponent from '@/components/user/profile/ProfileTitleComponent'
import CreateOrModifyVideo from '@/components/video/CreateOrModifyVideo.vue'

const apiUserConnected = new APIUserConnected()

export default {
  name: 'LearnNewVideo',
  components: {
    ProfileTitleComponent,
    CreateOrModifyVideo,
  },
  data() {
    return {
      categories: [
        this.$t('learn_modify_video.categories.recreational_pilot'),
        this.$t('learn_modify_video.categories.professional_pilot'),
        this.$t('learn_modify_video.categories.commercial_crew'),
        this.$t('learn_modify_video.categories.aircraft_mechanic'),
        this.$t('learn_modify_video.categories.drone_operator'),
        this.$t('learn_modify_video.categories.engineering'),
        this.$t('learn_modify_video.categories.traffic_controller'),
      ],
      video:{
        categories: [],
        language: 'EN',
        title: '',
        description: '',
        file: null,
      },
      publishConfirmationModal: false,
    }
  },
  mounted() {
    this.$store.commit('loadFromAPI')
    this.getVideo()
    this.$store.commit('endLoadingFromAPI')
  },
  methods: {
    async deleteVideo () {
      this.$store.commit('loadFromAPI')
      await apiUserConnected.deleteVideo(this.video.id)
      this.$store.commit('endLoadingFromAPI')
      this.$root.$bvToast.toast(this.$t('learn_modify_video.video_deleted_message'), {
        title: this.$t('learn_modify_video.video_deleted_title'),
        autoHideDelay: 5000,
        appendToast: false,
        variant: "success"
      })
      this.$router.push('/user/account/content')
    },
    async getVideo () {
      apiUserConnected.getVideo(this.$route.params.id)
      .then((response) => {
        this.video = response.data
      })
      .catch((error) => {
        throw new Error('getAd API Error : ' + String(error))
      })
    },
    async modifyVideo(video) {
      console.log(video)
      this.$store.commit('loadFromAPI')
      const formData = new FormData()
      formData.append('categories', JSON.stringify(video.categories))
      formData.append('title', video.title)
      formData.append('description', video.description)
      formData.append('language', video.language)
      formData.append('image_cover', video.image_cover)
      formData.append('video_access_option', video.video_access_option)
      formData.append('status', video.status)
      if (video.price !== null && video.price !== undefined && video.price !== '') {
        formData.append('price', video.price)
      }

      await apiUserConnected.modifyVideo(this.$route.params.id, formData)
      this.$store.commit('endLoadingFromAPI')
      
      // Show modal for VALIDATED, toast for DRAFT
      if (video.status === 'VALIDATED') {
        this.publishConfirmationModal = true
      } else {
        this.$root.$bvToast.toast(this.$t('learn_modify_video.video_modified_message'), {
          title: this.$t('learn_modify_video.video_modified_title'),
          autoHideDelay: 5000,
          appendToast: false,
          variant: "success"
        })
        this.$router.push('/user/account/content')
      }
    },
    closePublishModal() {
      this.publishConfirmationModal = false
      this.$router.push('/user/account/content')
    }
  },
}
</script>

